export const CHART_PALETTE = {
    GOLDEN: {
        lineColor1: "#fd8701",
        lineColor2: "#ffdc01",
        fillColor1: "rgba(253,152,1,17.5%)",
        fillColor2: "rgba(253,152,1,0)",
        dashColor1: "rgba(255,196,1,75%)",
        dashColor2: "rgba(255,196,1,5%)",
    },
    POSITIVE: {
        lineColor2: "#e3ff00",
        lineColor1: "#00ff01",
        fillColor1: "rgba(96,236,124,17.5%)",
        fillColor2: "rgba(96,236,124,0)",
        dashColor1: "rgba(221,251,1,75%)",
        dashColor2: "rgba(221,251,1,5%)",
    },
    NEGATIVE: {
        lineColor1: "#7f4cb4",
        // lineColor2: "#4e4357",
        lineColor2: "#674fa2",
        fillColor1: "rgba(127,76,180,17.5%)",
        fillColor2: "rgba(127,76,180,0)",
        dashColor1: "rgba(150,94,178,75%)",
        dashColor2: "rgba(150,94,178,5%)",
    },
}

export const getChartGradients = (palette, chartRef) => {

    const chartArea = chartRef.current?.chartArea
    const ctx = document.createElement('canvas')?.getContext("2d")

    const {
        lineColor1,
        lineColor2,
        fillColor1,
        fillColor2,
        dashColor1,
        dashColor2,
    } = palette


    const lineGradient = ctx.createLinearGradient(chartArea?.left || 0, 0, chartArea?.right || 0, 0);
    lineGradient.addColorStop(1, lineColor1);
    lineGradient.addColorStop(0, lineColor2);

    const annotationGradient = ctx.createLinearGradient(chartArea?.top || 0, 0, chartArea?.bottom || 500, 0);
    annotationGradient.addColorStop(1, 'rgba(255,255,255,0)');
    annotationGradient.addColorStop(.921, 'rgba(255,255,255,0)');
    annotationGradient.addColorStop(.92, lineColor1);
    annotationGradient.addColorStop(0, fillColor2);

    const backgroundGradient = ctx.createLinearGradient(0, chartArea?.bottom || 0, 0, chartArea?.top || 500);
    backgroundGradient.addColorStop(1, fillColor1);
    backgroundGradient.addColorStop(0, fillColor2);

    const latestValueGradient = ctx.createLinearGradient(chartArea?.left || 0, 0, chartArea?.right || 0, 0);
    latestValueGradient.addColorStop(1, dashColor1);
    latestValueGradient.addColorStop(.1, dashColor2);

    return {
        lineGradient,
        annotationGradient,
        backgroundGradient,
        latestValueGradient,
    }

}